var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.015 0L0 5.14875V26.1938H7.16375V30H11.1938L15 26.1938H20.8212L28.6575 18.3575V0H2.015V0ZM25.97 17.015L21.4925 21.4925H14.3288L10.5225 25.2987V21.4925H4.4775V2.68625H25.97V17.015ZM21.4925 7.83625V15.6637H18.8062V7.83625H21.4925ZM14.3288 7.83625V15.6637H11.6425V7.83625H14.3288Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitch);
export default __webpack_public_path__ + "static/media/icon-twitch.b0d26db412ac2326b3b47faf0bb92d05.svg";
export { ForwardRef as ReactComponent };